import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tipId"];
import { useState } from 'react';
import CoachingTip from './components/CoachingTip';
import useIsCoachingTipsDismissed from './hooks/useIsCoachingTipsDismissed';
import { useIsOnboardingComponentActive } from './hooks/useIsOnboardingComponentActive';
import { useBeforeEnter } from './hooks/useBeforeEnter';
import { setConfigForSelenium } from './utils/selenium';
import { createElement as _createElement } from "react";
const TIP_ID_PREFIX = 'coaching-tips';
const UICoachingTips = ({
  config
}) => {
  const {
    id,
    tips,
    beforeEnter
  } = config;
  // Hook to verify if we should wait to render the Coaching Tips
  const isReadyToEnter = useBeforeEnter(beforeEnter);

  // Hook to verify if there is currently any active onboarding-tour
  const isOnboardingTourActive = useIsOnboardingComponentActive();

  // Hook to verify the current status (dismissed or not) of this coaching tips
  const {
    isCoachingTipsDismissed,
    dismissCoachingTips
  } = useIsCoachingTipsDismissed(id);
  // Current open coaching tip
  const [currentTipId, setCurrentTipId] = useState('');
  const shouldRenderCoachingTips = !isCoachingTipsDismissed && !isOnboardingTourActive && isReadyToEnter;

  // Saves configuration on localstorage for ATs
  setConfigForSelenium(config);
  if (!shouldRenderCoachingTips) {
    return null;
  }
  return tips.map((tipConfig, index) => {
    const {
        tipId: propsTipId
      } = tipConfig,
      tipsConfig = _objectWithoutPropertiesLoose(tipConfig, _excluded);
    const tipIndex = index + 1;
    const tipId = propsTipId || `${TIP_ID_PREFIX}-${index}`;
    return /*#__PURE__*/_createElement(CoachingTip, Object.assign({
      coachingTipsId: id
    }, tipsConfig, {
      dismissCoachingTips: dismissCoachingTips,
      isOpen: tipId === currentTipId,
      key: tipId,
      tipId: tipId,
      tipIndex: tipIndex,
      setCurrentTipId: setCurrentTipId
    }));
  });
};
export default UICoachingTips;